import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function ListingCard({ item }) {
  const { t } = useTranslation()
  const [fav, setFav] = React.useState(false)
  const [idx, setIdx] = React.useState(0)

  const id = item.id ?? item.roomID
  const title = item.title ?? item.name ?? ''

  const images =
    Array.isArray(item.imageUrl) && item.imageUrl.length > 0
      ? item.imageUrl
      : [
          item.image ??
            'https://via.placeholder.com/800x450?text=Locapiol'
        ]

  const city = item.city ?? item.location?.city ?? ''
  const district = item.district ?? item.location?.district ?? ''

  const verified = !!(item.verified ?? item.isVerified)

  const priceLabel = item.priceLabel
    ?? `${item.price?.amount ?? ''} ${item.price?.currency ?? ''}`

  const tags = item.tags?.length ? item.tags : (item.type ? [item.type] : [])

  const prev = (e) => {
    e.preventDefault()
    setIdx((i) => (i - 1 + images.length) % images.length)
  }

  const next = (e) => {
    e.preventDefault()
    setIdx((i) => (i + 1) % images.length)
  }

  return (
    <Link
      to={`/annonce/${id}`}
      className="group block rounded-xl overflow-hidden bg-white hover:shadow-lg transition"
    >
      {/* IMAGE CAROUSEL */}
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={images[idx]}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />

        {/* LEFT / RIGHT */}
        {images.length > 1 && (
          <>
            <button
              onClick={prev}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow hidden group-hover:flex"
            >
              ‹
            </button>
            <button
              onClick={next}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow hidden group-hover:flex"
            >
              ›
            </button>
          </>
        )}

        {/* DOTS */}
        {images.length > 1 && (
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
            {images.map((_, i) => (
              <span
                key={i}
                className={`w-1.5 h-1.5 rounded-full ${
                  i === idx ? 'bg-white' : 'bg-white/50'
                }`}
              />
            ))}
          </div>
        )}

        {/* VERIFIED */}
        {verified && (
          <span className="absolute top-2 left-2 bg-white text-emerald-700 text-xs font-bold px-2 py-1 rounded-full shadow">
            ✔ {t('listing.verified')}
          </span>
        )}

        {/* FAVORITE */}
        <button
          onClick={(e) => {
            e.preventDefault()
            setFav((v) => !v)
          }}
          className="absolute top-2 right-2 bg-white p-2 rounded-full shadow"
        >
          <svg
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill={fav ? '#e11d48' : 'none'}
            stroke="#e11d48"
            strokeWidth="2"
          >
            <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8L12 22l7.8-8.6a5.5 5.5 0 0 0 0-7.8z" />
          </svg>
        </button>
      </div>

      {/* TEXT */}
      <div className="p-3">
        <h3 className="font-semibold text-base truncate">{title}</h3>
        <p className="text-sm text-gray-500 truncate">
          {district ? `${city} · ${district}` : city}
        </p>
        <p className="mt-1 font-bold">{priceLabel}</p>

        <div className="flex gap-1 mt-2 flex-wrap">
          {tags.map((tg, i) => (
            <span
              key={i}
              className="text-xs px-2 py-0.5 rounded-full bg-blue-50 border border-blue-100"
            >
              {tg}
            </span>
          ))}
        </div>
      </div>
    </Link>
  )
}
